import { Skeleton, SkeletonProps } from "@mui/material";
import styles from "./styles.module.css";

interface Props extends SkeletonProps {
  className?: string;
}

export const AppSkeleton = ({ className, ...rest }: Props) => {
  return <Skeleton {...rest} className={className} />;
};
